import { useCallback, useEffect, useState } from 'react';
import { api } from '../services/api';
import type { Game } from '../types/game';

export function useAdminGame(slug: string) {
  const [game, setGame] = useState<Game | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try { setGame(await api.adminGame(slug)); setError(null); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'No se pudo cargar el panel.'); }
    finally { setLoading(false); }
  }, [slug]);

  useEffect(() => { void reload(); }, [reload]);
  return { game, error, loading, reload };
}

